export default __webpack_public_path__ + "static/logo-05e3a761d3d741157d603905f282dfc9.svg";